import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../../common/types';
import { useIsNarrowScreen } from '../../work/useIsNarrowScreen';
import { profileMessages as m } from '../profileMessages';
import { ProfileUpgradeButton } from './ProfileUpgradeButton';
import { withBrandWord } from '../../../components/primitives/BrandWord';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the Profile; each part uses its own slice of it */
import styles from '../Profile.module.scss';
/* eslint-enable css-modules/no-unused-class */

/** The Free banner (design a2, d4): half-size previews with the mark; Upgrade, or the owner note for a member. */
const ProfileFreeBannerComponent: React.FC = () => {
  const intl = useIntl();
  const narrow = useIsNarrowScreen();
  return (
    <div className={styles.freeBanner} data-testid="profile-free-banner">
      <div className={styles.grow}>
        <b>{withBrandWord(intl.formatMessage(narrow ? m.freeTitleNarrow : m.freeTitle))}</b>{' '}
        {intl.formatMessage(narrow ? m.freeBodyNarrow : m.freeBody)}
      </div>
      <ProfileUpgradeButton small />
    </div>
  );
};

export const ProfileFreeBanner = TypedMemo(ProfileFreeBannerComponent);
